import { ImageScaleView, View, ViewOpts } from '@play-co/timestep-core/ui';
import { downscale } from 'src/conf/scale';
import i18n from 'src/lib/i18n/i18n';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import { buddiesMilestoneThresholds } from 'src/replicant/buddies/buddies.ruleset';

export class BuddiesGrandPrize extends View {
  private base: ImageScaleView;
  private text: LangBitmapFontTextView;
  public index = buddiesMilestoneThresholds.length - 1;

  constructor(opts?: ViewOpts) {
    super({
      width: downscale(171),
      height: downscale(191),
      centerOnOrigin: true,
      ...opts,
    });

    this.base = new ImageScaleView({
      superview: this,
      width: this.style.width,
      height: this.style.height,
      scaleMethod: 'contain',
      x: this.style.width / 2,
      y: this.style.height / 2,
      image: `assets/ui/buddies/popupBaking/grandprize_mark.png`,
      centerAnchor: true,
      centerOnOrigin: true,
    });

    this.text = new LangBitmapFontTextView({
      superview: this,
      x: this.base.style.x - 2,
      y: this.base.style.y + 23,
      centerOnOrigin: true,
      align: 'center',
      verticalAlign: 'center',
      size: 22,
      font: 'Body',
      width: this.base.style.width - 30,
      height: 40,
      wordWrap: true,
    });
    this.text.localeText = () => i18n('match2.buddies.grandPrize');
  }
}
